import AvatarWithName from './AvatarWithName'

export default AvatarWithName
